var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E50914"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2929 22.7071C29.6834 23.0976 30.3166 23.0976 30.7071 22.7071C31.0976 22.3166 31.0976 21.6834 30.7071 21.2929L29.2929 22.7071ZM24 16L24.7071 15.2929C24.5196 15.1054 24.2652 15 24 15C23.7348 15 23.4804 15.1054 23.2929 15.2929L24 16ZM17.2929 21.2929C16.9024 21.6834 16.9024 22.3166 17.2929 22.7071C17.6834 23.0976 18.3166 23.0976 18.7071 22.7071L17.2929 21.2929ZM23 28C23 28.5523 23.4477 29 24 29C24.5523 29 25 28.5523 25 28L23 28ZM30.7071 21.2929L24.7071 15.2929L23.2929 16.7071L29.2929 22.7071L30.7071 21.2929ZM23.2929 15.2929L17.2929 21.2929L18.7071 22.7071L24.7071 16.7071L23.2929 15.2929ZM23 16L23 28L25 28L25 16L23 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 33L32 33",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/send-button.3ee58c88a7eb22c71f20f60f30dc2f71.svg";
export { ForwardRef as ReactComponent };